import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'
import { getValues } from '@/lib/values'

export const session_sessions = {

  namespaced: true,

  state: {
    assigned: [],
    filters: [
      { column: 'title', label: 'title', options: { type: false }, value: '', status: true },
    ],
    options: {
      title: { label: 'title', element: 'text' },
    },
    sessions: [],
    duration_all: null,
    order: null,
    duration: null,
    values: {},
    entities: [],
  },

  getters: {
    assigned: state => state.assigned,
    filters: state => state.filters,
    options: state => state.options,
    sessions: state => state.sessions,
    duration_all: state => state.duration_all,
    order: state => state.order,
    duration: state => state.duration,
    values: state => state.values,
    entities: state => state.entities,
  },

  mutations: {
    setAssigned(state, assigned) { state.assigned = assigned },
    setOptions(state, options) { state.options = options },
    setSessions(state, sessions) {
      sessions = sessions.map(session => {
        session.order = null;
        return session;
      })
      state.sessions = sessions;
    },
    setDurationAll(state, duration_all) {
      state.duration_all = duration_all;
    },
    setOrder(state, order) { state.order = order },
    setDuration(state, duration) { state.duration = duration },
    setValues(state, values) { 
      for (let column in values) {
        Vue.set(state.values, column, values[column]);
      }
    },
    setEntities(state, entities) { state.entities = entities },
    clearFilters(state) {
      state.filters = [
        { column: 'title', label: 'title', options: { type: false }, value: '', status: true },
      ];
      state.options = {
        title: { label: 'title', element: 'text' },
      };
    },
  },

  actions: {

    getAssigned: () => Vue.axios.get(API_URL + '/sessions/' + router.currentRoute.params.id + '/sessions'),

    getOptions: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Session'],
      filter_display: true,
    }}),

    getEntities: () =>  Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Session'],
      form_display: true,
      form_compact: true,
    }}),

    async getAssignedSessions({ commit, dispatch }) {
      commit('clearResponse', {}, { root: true });
      commit('setAssigned', []);
      const [assigned, options, entities] = await Promise.all([
        dispatch('getAssigned'),
        dispatch('getOptions'),
        dispatch('getEntities'),
      ]);
      commit('setProgress', false, { root: true });
      commit('setAssigned', assigned.data);
      commit('setOptions', options.data['App\\Models\\Session'].filters);
      commit('setValues', getValues('session', entities.data['App\\Models\\Session'], 'content'));
      commit('setEntities', entities.data['App\\Models\\Session']);

      // state.options.assigned = {
      //   format: 'wording',
      //   label: 'assigned',
      //   element: 'radio',
      //   custom: true,
      //   options: [
      //     { value: 'yes', name: 'yes' },
      //     { value: 'no', name: 'no' },
      //   ],
      // };
    },

    async addSessions({ state, rootState, commit }, params) {
      if (!rootState.progress && params.sessions.length > 0) {
        let ids = params.sessions.reduce((carry, pval) => { carry.push(pval.id); return carry; }, []);
        const assigned = await Vue.axios.post(API_URL + '/sessions/' + router.currentRoute.params.id + '/sessions', {
          session_id: router.currentRoute.params.id,
          sessions: params.sessions,
        });
        commit('setSessions', state.sessions.filter(session => !ids.includes(session.id)));
        commit('setProgress', false, { root: true });
        commit('clearResponse', {}, { root: true });
        commit('setValues', getValues('session', state.entities, 'content'));
        commit('setAssigned', assigned.data);
      }
    },

    async updateSessions({ rootState, state, commit }) {
      if (!rootState.progress) {
        const assigned = await Vue.axios.put(API_URL + '/sessions/' + router.currentRoute.params.id + '/sessions', state.assigned);
        commit('setProgress', false, { root: true });
        commit('setAssigned', assigned.data);
      }
    },

    async removeSession({ rootState, commit, dispatch }, id) {
      if (!rootState.progress) {
        const assigned = await Vue.axios.delete(API_URL + '/sessions/' + router.currentRoute.params.id + '/sessions/' + id);
        commit('setProgress', false, { root: true });
        commit('setAssigned', assigned.data);
        await dispatch('getSessions');
      }
    },

    async getSessions({ state, rootState, getters, commit }) {
      if (!rootState.progress) {
        let assigned = state.assigned.reduce((carry, session) => { 
          carry.push(session.id);
          return carry;
        }, []);
        commit('setSessions', []);
        let filters = (state.assigned.length > 0)
          ? getters.filters.concat([
              { column: 'id', not: true, value: assigned.join(','), status: true }
            ])
          : getters.filters;
        filters = filters.concat([
          { column: 'display_type_id', not: false, value: 1, status: true },
          { column: 'day_id', not: false, value: rootState.session.session.day_id, status: true },
          { column: 'room_id', not: false, value: rootState.session.session.room_id, status: true },
          { column: 'start_time', not: false, value: rootState.session.session.start_time, status: true },
          { column: 'end_time', not: false, value: rootState.session.session.end_time, status: true },
        ]);
        const sessions = await Vue.axios.get(API_URL + '/sessions', {
          params: {
            with: 'persons.person',
            filters: filters,
            limit: 500,
          }
        })
        .catch(() => {
          commit('setProgress', false, { root: true });
        });
        commit('setProgress', false, { root: true });
        commit('setSessions', sessions.data.items);
      }
    },

  }
}
